<p-button styleClass="bar-menu-button" (click)="toggle()">
    <i class="fa-solid fa-bars" *ngIf="!open"></i>
    <i class="fa-solid fa-xmark" *ngIf="open"></i>
</p-button>
